// The COARSE failure state the `payment-setup` edge function 302s here with
// (issue #209 + follow-up). The client only ever sees `state` — `recoverable`
// or `non_recoverable` — never the internal granular reason
// (`missing_token`/`invalid_link`/`no_account`/`unavailable`), which would tell a
// stranger poking tokens exactly which check failed. The granular code stays
// server-side, in the `payment_setup_error` telemetry event and the
// `X-Payment-Setup-Error` response header. Kept out of PaymentSetupError.tsx so
// that file only exports components (react-refresh), and so the state list has
// one home matching PaymentSetupErrorState in
// shoots-server/supabase/functions/payment-setup/handler.ts.
//
// NOTE there is deliberately no `expired`: the payment-setup token is a stateless
// HMAC over the profile id with no expiry claim, so it cannot expire. (Issue #209
// assumed otherwise.) What expires is the Stripe Account Link it resolves to, and
// that self-heals through Stripe's refresh_url.
export type PaymentSetupErrorState = 'recoverable' | 'non_recoverable'

const STATES: readonly PaymentSetupErrorState[] = ['recoverable', 'non_recoverable']

/** An absent or unrecognized state still gets a real, recoverable page — never a
 * blank one, and never a dead end. `recoverable` is the safe default: a fresh
 * link is usually the fix, so we show the form. */
export function parseErrorState(raw: string | null): PaymentSetupErrorState {
  return STATES.includes(raw as PaymentSetupErrorState)
    ? (raw as PaymentSetupErrorState)
    : 'recoverable'
}
